<template>
  <div>
    <div class="columns is-marginless">
      <div class="column buttons is-paddingless">
        <button v-if="displayArrow" class="button"
                @click='customMove ? customPrevious() : previous()'>
          <b-icon icon="chevron-left" size="is-small" type="is-default"></b-icon>
        </button>
        <button class="button colonneWith180" @click='popinneEnable = !popinneEnable'>
          {{ getDate }}
        </button>
        <button v-if="displayArrow" class="button"
                @click='customMove ? customNext() : next()'>
          <b-icon icon="chevron-right" size="is-small" type="is-default"></b-icon>
        </button>
      </div>
    </div>
    <div class="column has-background-white width-340 is-fixed card entete mgt-10px"
         v-if="popinneEnable">
      <div class="mgb-10px columns is-multiline">
        <div class="column has-text-weight-bold">
          {{ $t('renouvellementCommande.periode') }}
        </div>
        <div class="column is-narrow">
          <a @click="sendUpdate()">
            <b-icon icon="close"
              class="icon is-pulled-right has-text-icon-more">
            </b-icon>
          </a>
        </div>
        <div class="column is-12">
          <b-field>
            <b-datepicker show-week-number
                          v-model="dates.dateDebut"
                          icon="calendar-today"
                          @input="setEndDate()"
                          editable :position="position"
                          nearby-selectable-month-days
            ></b-datepicker>
            <div class="mg-auto mgl-10px mgr-10px">
              {{$t('renouvellementCommande.au')}}
            </div>
            <b-datepicker show-week-number
                          v-model="dates.dateFin"
                          icon="calendar-today"
                          @input="triggerSearchEveryTime ? sendUpdate() : null"
                          editable :position="position"
                          nearby-selectable-month-days
            ></b-datepicker>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'datePicker',
  props: {
    dates: Object,
    updateEndDateAtChangeStartDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    customMove: {
      type: Boolean,
      required: false,
      default: false,
    },
    position: {
      type: String,
      required: false,
      default: 'is-bottom-right',
    },
    displayArrow: {
      type: Boolean,
      required: false,
      default: true,
    },
    triggerSearchEveryTime: {
      type: Boolean,
      required: false,
      default: true,
    },
    time: {
      type: String,
      required: false,
      default: 'months',
    },
    amount: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  data() {
    return {
      popinneEnable: false,
    };
  },
  computed: {
    getDate() {
      return this.$t('renouvellementCommande.dateDebutToDateFin', { dateDebut: formatDate(this.dates.dateDebut), dateFin: formatDate(this.dates.dateFin) });
    },
  },
  methods: {
    sendUpdate() {
      this.popinneEnable = false;
      this.$emit('recherche');
    },
    setEndDate() {
      if (this.updateEndDateAtChangeStartDate) {
        if (this.dates.dateDebut === null) {
          this.dates.dateFin = null;
          if (this.triggerSearchEveryTime) this.$emit('recherche');
          return;
        }
        if (this.time === 'years') {
          this.dates.dateFin = moment(this.dates.dateDebut)
            .add(this.amount, this.time)
            .add(-1, 'days')
            .toDate();
        } else {
          this.dates.dateFin = moment(this.dates.dateDebut)
            .add(this.amount, this.time)
            .toDate();
        }
      }
      if (this.triggerSearchEveryTime) this.$emit('recherche');
    },
    changeDate(year, month) {
      this.dates.dateDebut = (moment([year, month])).toDate();
      this.dates.dateFin = (moment(this.dates.dateDebut).endOf('month')).toDate();
      this.$emit('recherche');
    },
    next() {
      if (!this.dates.dateDebut || !this.dates.dateFin) return;
      const month = this.dates.dateDebut.getMonth() + 1 >= 12 ? 0
        : this.dates.dateDebut.getMonth() + 1;
      const year = this.dates.dateDebut.getMonth() + 1 < 12 ? this.dates.dateDebut.getFullYear()
        : this.dates.dateDebut.getFullYear() + 1;
      this.changeDate(year, month);
    },
    customNext() {
      if (!this.dates.dateDebut || !this.dates.dateFin) return;
      this.dates.dateDebut = moment(this.dates.dateDebut).add(1, this.time).toDate();
      this.dates.dateFin = moment(this.dates.dateFin).add(1, this.time).toDate();
      this.$emit('recherche');
    },
    previous() {
      if (!this.dates.dateDebut || !this.dates.dateFin) return;
      const month = this.dates.dateDebut.getMonth() - 1 < 0 ? 11
        : this.dates.dateDebut.getMonth() - 1;
      const year = this.dates.dateDebut.getMonth() - 1 >= 0 ? this.dates.dateDebut.getFullYear()
        : this.dates.dateDebut.getFullYear() - 1;
      this.changeDate(year, month);
    },
    customPrevious() {
      if (!this.dates.dateDebut || !this.dates.dateFin) return;
      this.dates.dateDebut = moment(this.dates.dateDebut).subtract(1, this.time).toDate();
      this.dates.dateFin = moment(this.dates.dateFin).subtract(1, this.time).toDate();
      this.$emit('recherche');
    },
  },
};
</script>
